// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-form-container {
    position: fixed;
    top: 50%;
    left: 50%;
    height: 80vh;
    width: 70vw;
    transform: translate(-50%, -50%);
    background-color: white;
    border-radius: 1em;
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    z-index: 1000;
    overflow-y: auto;
    /* overflow-x: auto; */
}


@media (max-width: 500px) {
    .profile-form-container{
        width: 90%;
    }
}

@media (max-width: 400px) {
    .profile-form-container{
        width: 80vw;
    }
}

@media (max-height:1300px) {
    .profile-form-container{
       height: 50vh;
    }
}

@media (max-height:800px) {
    .profile-form-container{
       height: 80vh;
       width:89%;
    }
}






#score-display{
    display:flex;
    justify-content: space-around;
    font-weight: bold;
    padding-bottom:10px;
}

.profile-header{
    display: grid;
    justify-content: space-between;
    align-items: center;
}


#profile-pic-display{
    border-radius: 50%;
    width:50px;
    height:50px;
    vertical-align:middle;
    margin-top:5px;
    display:inline-block
}


#profile-pic{
    display:flex;
    justify-content: space-evenly;
    margin-left:10%;
}

.profile-page-edit{
    background-color: #007bff;
    border: none;
    border-radius: 1em;
    color: white;
    margin: 0.25em;
    padding:5px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
}

#username-display{
    margin-left:10px;
    font-size: 15pt;
}

.close-x{
    grid-column:2;
}


#upload-new-picture{
    display:none;
}


.profile-row{
    display: flex;
    justify-content: space-between;
}


.profile-info, .profile-edit{
    float:right;
    height:25px;
    max-width:78px;
    padding-left:6px;
    padding-right:6px;
    background-color: #007bff;
    border: none;
    border-radius: 50px;
    color: white;

    margin-right:3px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
}

.profile-delete{
    float:right;
    height:25px;
    max-width:70px;
    padding-left:10px;
    padding-right:10px;
    background-color: rgba(234, 13, 9, 0.884);
    border: none;
    border-radius: 50px;
    color: white;
    margin-right:3px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
}


@media (max-width:350px){
    .profile-info, .profile-edit {
        width:30px;
        font-size:10px;
    }

    .profile-delete{
        font-size:10px;
        width:47%;
    }

    .profile-edit, .profile-delete{
        margin-right:2px;
    }
}


.add-label{
    float:right;
    width:15%;
    background-color: #007bff;
    border: none;
    border-radius: 50px;
    color: white;
    margin: 0.25em;
    margin-right:10px;
    margin-top:10px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
}


.profile-info:hover, .profile-edit:hover{
    background-color:#004c9e;
}

.profile-delete:hover{
    background-color: #913f3f;
}



input[type="radio"]{
    margin-left:0px;;
    float:right;
}

label{
    float:left;
    margin-right:2px;
}


#label-row{
    margin:none;
    /* display: inline-flex; */
    align-items: center;
}


#label-key{
    margin-right:auto;
}

.label-entry, .profile-label-container{
    border: 1px solid #007bfff6;;
    border-radius: 1em;
    margin: 0.25em;
    padding:10px;
    font-size: 12px;
    display:inline-block;
    text-align:center;
}

.checkbox-label{
    display:inline-block;
}

input[type=checkbox]{
    margin-left:5px;
}


#profile-delete{
    margin-top:20px;
    background-color: rgba(234, 13, 9, 0.884);
    padding:5px;
    padding-left:20px;
    padding-right:20px;
    border: none;
    border-radius: 1em;
    color:white;
}

.other-profile-image{
    width:70px;
    height:70px;
}
`, "",{"version":3,"sources":["webpack://./src/css/profileForm.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;IACX,gCAAgC;IAChC,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,2CAA2C;IAC3C,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;;;AAGA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;OACG,YAAY;IACf;AACJ;;AAEA;IACI;OACG,YAAY;OACZ,SAAS;IACZ;AACJ;;;;;;;AAOA;IACI,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,cAAc;IACd;AACJ;;;AAGA;IACI,YAAY;IACZ,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,eAAe;IACf,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,8BAA8B;AAClC;;;AAGA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,YAAY;;IAEZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,wDAAwD;AAC5D;;;AAGA;IACI;QACI,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;AACJ;;;AAGA;IACI,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,eAAe;IACf,wDAAwD;AAC5D;;;AAGA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;;AAGA;IACI,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;AACvB;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,eAAe;IACf,yCAAyC;IACzC,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;AACf","sourcesContent":[".profile-form-container {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    height: 80vh;\n    width: 70vw;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    border-radius: 1em;\n    padding: 20px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n    overflow-y: auto;\n    /* overflow-x: auto; */\n}\n\n\n@media (max-width: 500px) {\n    .profile-form-container{\n        width: 90%;\n    }\n}\n\n@media (max-width: 400px) {\n    .profile-form-container{\n        width: 80vw;\n    }\n}\n\n@media (max-height:1300px) {\n    .profile-form-container{\n       height: 50vh;\n    }\n}\n\n@media (max-height:800px) {\n    .profile-form-container{\n       height: 80vh;\n       width:89%;\n    }\n}\n\n\n\n\n\n\n#score-display{\n    display:flex;\n    justify-content: space-around;\n    font-weight: bold;\n    padding-bottom:10px;\n}\n\n.profile-header{\n    display: grid;\n    justify-content: space-between;\n    align-items: center;\n}\n\n\n#profile-pic-display{\n    border-radius: 50%;\n    width:50px;\n    height:50px;\n    vertical-align:middle;\n    margin-top:5px;\n    display:inline-block\n}\n\n\n#profile-pic{\n    display:flex;\n    justify-content: space-evenly;\n    margin-left:10%;\n}\n\n.profile-page-edit{\n    background-color: #007bff;\n    border: none;\n    border-radius: 1em;\n    color: white;\n    margin: 0.25em;\n    padding:5px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n}\n\n#username-display{\n    margin-left:10px;\n    font-size: 15pt;\n}\n\n.close-x{\n    grid-column:2;\n}\n\n\n#upload-new-picture{\n    display:none;\n}\n\n\n.profile-row{\n    display: flex;\n    justify-content: space-between;\n}\n\n\n.profile-info, .profile-edit{\n    float:right;\n    height:25px;\n    max-width:78px;\n    padding-left:6px;\n    padding-right:6px;\n    background-color: #007bff;\n    border: none;\n    border-radius: 50px;\n    color: white;\n\n    margin-right:3px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n}\n\n.profile-delete{\n    float:right;\n    height:25px;\n    max-width:70px;\n    padding-left:10px;\n    padding-right:10px;\n    background-color: rgba(234, 13, 9, 0.884);\n    border: none;\n    border-radius: 50px;\n    color: white;\n    margin-right:3px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n}\n\n\n@media (max-width:350px){\n    .profile-info, .profile-edit {\n        width:30px;\n        font-size:10px;\n    }\n\n    .profile-delete{\n        font-size:10px;\n        width:47%;\n    }\n\n    .profile-edit, .profile-delete{\n        margin-right:2px;\n    }\n}\n\n\n.add-label{\n    float:right;\n    width:15%;\n    background-color: #007bff;\n    border: none;\n    border-radius: 50px;\n    color: white;\n    margin: 0.25em;\n    margin-right:10px;\n    margin-top:10px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n}\n\n\n.profile-info:hover, .profile-edit:hover{\n    background-color:#004c9e;\n}\n\n.profile-delete:hover{\n    background-color: #913f3f;\n}\n\n\n\ninput[type=\"radio\"]{\n    margin-left:0px;;\n    float:right;\n}\n\nlabel{\n    float:left;\n    margin-right:2px;\n}\n\n\n#label-row{\n    margin:none;\n    /* display: inline-flex; */\n    align-items: center;\n}\n\n\n#label-key{\n    margin-right:auto;\n}\n\n.label-entry, .profile-label-container{\n    border: 1px solid #007bfff6;;\n    border-radius: 1em;\n    margin: 0.25em;\n    padding:10px;\n    font-size: 12px;\n    display:inline-block;\n    text-align:center;\n}\n\n.checkbox-label{\n    display:inline-block;\n}\n\ninput[type=checkbox]{\n    margin-left:5px;\n}\n\n\n#profile-delete{\n    margin-top:20px;\n    background-color: rgba(234, 13, 9, 0.884);\n    padding:5px;\n    padding-left:20px;\n    padding-right:20px;\n    border: none;\n    border-radius: 1em;\n    color:white;\n}\n\n.other-profile-image{\n    width:70px;\n    height:70px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
